import { render } from "./AppWrapper.vue?vue&type=template&id=835f33fc&scoped=true"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=835f33fc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-835f33fc"

export default script